<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="p-1 mx-auto"
                        md="3"
                        :data-img="image.id"
                >
                    <v-radio-group v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <v-img
                            :src="image.full_path"
                            :lazy-src="image.full_path"
                            aspect-ratio="1"
                            :key="image.id"
                    >
                    </v-img>
                    <p class="text-center mr-5">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "tarahiSet",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'اداری/سازمانی',
                    value: 'official',
                    full_path: require('../../../../public/media/site/tarahiSET/رسمی.jpg')
                },
                {
                    id: '2',
                    name: 'خلاق',
                    value: 'innovative',
                    full_path: require('../../../../public/media/site/tarahiSET/خلاق.jpg')
                },  {
                    id: '3',
                    name: 'عمومی',
                    value: 'public',
                    full_path: require('../../../../public/media/site/tarahiSET/عمومی.jpg')
                },
                {
                    id: '3',
                    name: 'ساده',
                    value: 'simple',
                    full_path: require('../../../../public/media/site/tarahiSET/ساده .jpg')
                },
                {
                    id: '3',
                    name: 'کلاسیک',
                    value: 'classic',
                    full_path: require('../../../../public/media/site/tarahiSET/کلاسیک.jpg')
                },
                {
                    id: '3',
                    name: 'لوکس',
                    value: 'luxury',
                    full_path: require('../../../../public/media/site/tarahiSET/لوکس.jpg')
                },
                {
                    id: '3',
                    name: 'فانتزی',
                    value: 'unusual',
                    full_path: require('../../../../public/media/site/tarahiSET/فانتزی.jpg')
                },
                {
                    id: '3',
                    name: 'مدرن',
                    value: 'modern',
                    full_path: require('../../../../public/media/site/tarahiSET/مدرن.jpg')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"tarahiSet")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>